import { CircularProgress } from '@vapor/material'
import { Backdrop } from '@mui/material'

const HICLoading = () => {
  return (
    <Backdrop open sx={{ backgroundColor: 'rgba(0,0,0,0.15)', zIndex: 999 }}>
      <CircularProgress color="secondary" />
    </Backdrop>
  )
}

export default HICLoading
